// extracted by mini-css-extract-plugin
export var WebGlContainer = "webgl-module--WebGlContainer--jLiUX";